"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayValidator = void 0;
const Validator_1 = require("../validator/Validator");
const ERRORS = {
    ARRAY_CONTENT: 'ARRAY_CONTENT',
    ARRAY_OBJECT: 'ARRAY_OBJECT',
    IS_ARRAY: 'IS_ARRAY',
    MAX_LENGTH: 'MAX_LENGTH',
    MIN_LENGTH: 'MIN_LENGTH',
    NOT_EMPTY: 'NOT_EMPTY',
};
class ArrayValidator extends Validator_1.Validator {
    static isArray(value) {
        return Array.isArray(value);
    }
    static notEmpty(value) {
        return value.length > 0;
    }
    static minLength(value, min) {
        return _a.isArray(value) && value.length >= min;
    }
    static maxLength(value, max) {
        return _a.isArray(value) && value.length <= max;
    }
    static arrayContent(value, contentType) {
        return _a.isArray(value) && value.every(item => typeof item === contentType);
    }
    static arrayObject(value, fieldsValidator) {
        return _a.isArray(value) && value.every(item => fieldsValidator.validate(item).isSuccess);
    }
}
exports.ArrayValidator = ArrayValidator;
_a = ArrayValidator;
ArrayValidator.IS_ARRAY = () => _a.validatorFactory(_a.isArray, ERRORS.IS_ARRAY);
ArrayValidator.NOT_EMPTY = () => _a.validatorFactory(_a.notEmpty, ERRORS.NOT_EMPTY);
ArrayValidator.MIN_LENGTH = (min) => _a.validatorFactory(value => _a.minLength(value, min), ERRORS.MIN_LENGTH);
ArrayValidator.MAX_LENGTH = (max) => _a.validatorFactory(value => _a.maxLength(value, max), ERRORS.MAX_LENGTH);
ArrayValidator.ARRAY_CONTENT = (contentType) => _a.validatorFactory(value => _a.arrayContent(value, contentType), ERRORS.ARRAY_CONTENT);
ArrayValidator.ARRAY_OBJECT = (fieldsValidator) => _a.validatorFactory(value => _a.arrayObject(value, fieldsValidator), ERRORS.ARRAY_OBJECT);
//# sourceMappingURL=ArrayValidator.js.map